export default from './message';
export * from './messages';



// WEBPACK FOOTER //
// ./app/components/message/index.js